import { Locale } from 'modules/i18n';

export const grpcCodeExampleTranslation = {
  [Locale.en]: {
    codeExample: 'Code example',
  },
};
